export const languages = {
  en: 'English',
  es: 'Español',
  ca: 'Català',
  pt: 'Português',
  'pt-br': 'Português - Brasil',
};

export const LANGUAGES = Object.keys(languages);
